import _regeneratorRuntime from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.unescape.js";
import "core-js/modules/web.btoa.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import "core-js/modules/web.timers.js";
import WalkthroughPointer from "@/components/WalkthroughPointer.vue";
import { defineComponent } from "vue";
export default defineComponent({
  name: "ActionBar",
  components: {
    WalkthroughPointer: WalkthroughPointer
  },
  setup: function setup() {
    return {};
  },
  mounted: function mounted() {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  watch: {
    // "$store.state.queuedCloudTTSSentences": "processCloudTTSPayloads",
  },
  props: {},
  data: function data() {
    return {
      aiIsResponding: false
      // data
    };
  },
  methods: {
    cameraClick: function cameraClick() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(_this.$store.state.continuousListenMode === false)) {
                _context2.next = 5;
                break;
              }
              _context2.next = 3;
              return _this.$store.dispatch('checkFeatureEnabled', 'camera');
            case 3:
              _context2.next = 8;
              break;
            case 5:
              console.log('showing video');
              _context2.next = 8;
              return _this.$store.dispatch('checkFeatureEnabled', 'video');
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    startTalkingNow: function startTalkingNow() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var blob, localHere, result;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(localStorage.getItem('limitReached') === 'true' || localStorage.getItem('limitReached') === true)) {
                _context3.next = 5;
                break;
              }
              _this2.$store.commit('updateUpgradeModalMessage', 'limitreached');
              _this2.$store.commit("updateShowUpgradeMembershipPage", true);
              _this2.$store.commit('updateLimitReached', true);
              return _context3.abrupt("return");
            case 5:
              if (!(_this2.$store.state.onDeviceAudioRecording === false)) {
                _context3.next = 12;
                break;
              }
              // play brilliance sound listening
              if (_this2.$store.state.brillianceMode) {
                _this2.aiListening.play();
              }
              if (!(_this2.$store.state.limitReached === true || _this2.$store.state.limitReached === "true")) {
                _context3.next = 12;
                break;
              }
              _this2.$store.commit('updateUpgradeModalMessage', 'limitreached');
              _this2.$store.commit("updateShowUpgradeMembershipPage", true);
              _this2.$store.commit('updateLimitReached', true);
              return _context3.abrupt("return");
            case 12:
              if (!(_this2.alreadyTalking && !_this2.simultaneousTalking)) {
                _context3.next = 16;
                break;
              }
              console.log("halting convo");
              _this2.haltTalking = true;
              return _context3.abrupt("return");
            case 16:
              if (!(_this2.$store.state.continuousListenMode && _this2.$store.state.userTalking && _this2.$store.state.onDeviceAudioRecording === true && !_this2.question)) {
                _context3.next = 19;
                break;
              }
              _this2.startTalkingNowOnDevice();
              return _context3.abrupt("return");
            case 19:
              if (!(_this2.$store.state.userTalking && _this2.$store.state.onDeviceAudioRecording === true && !_this2.question)) {
                _context3.next = 21;
                break;
              }
              return _context3.abrupt("return");
            case 21:
              // if(this.$store.state.onDeviceAudioRecording === true){
              localHere = _this2;
              setTimeout(function () {
                localHere.$store.commit("updateFloatingText", "");
              }, 4000);
              // }
              if (!(_this2.$store.state.onDeviceAudioRecording === false)) {
                _context3.next = 28;
                break;
              }
              // preload SOMETHING so we can reuse it later on
              // preloadAudio('audioClip', '/assets/audio/ahhuhhuh.mp3');
              // await playAudioByName('audioClip');
              // this.setAnimationListening();
              _this2.$store.commit('updateUserTalking', true);
              // start talking

              // THIS IS THE MAIN SPEECH TO TEXT FUNCTION WE ARE IN
              _context3.next = 27;
              return _this2.startRecording();
            case 27:
              blob = _context3.sent;
            case 28:
              if (_this2.$store.state.brillianceMode) {
                _this2.aiProcessing.play();
              }
              _this2.$store.commit('updateUserTalking', false);
              _this2.$store.commit("updateIsListening", false);
              _this2.isListening = false;
              _this2.resetMouthDefaults();

              // if it came back marked as silence (no input) then we need to reask the question
              if (!(blob === "haltTalking")) {
                _context3.next = 39;
                break;
              }
              _this2.haltTalking = false;
              console.log("halting talking");
              _this2.$store.commit('updateaiTalking', false);
              _this2.alreadyTalking = false;
              return _context3.abrupt("return");
            case 39:
              if (!(blob === "silence")) {
                _context3.next = 47;
                break;
              }
              console.log("silence detected");
              // say we didn't hear
              // await this.playAudio('/assets/audio/DidntHearYou.mp3');
              // await audioDidntHearYou();
              _this2.$store.commit('updateaiTalking', true);
              _context3.next = 44;
              return _this2.textToSpeech("Sorry, I didn't hear you. Did you say something? If so, try to speak louder perhaps.");
            case 44:
              // preloadAudio('audioClip', '/assets/audio/DidntHearYou.mp3');
              // await playAudioByName('audioClip');
              _this2.$store.commit('updateaiTalking', false);
              // reask the question
              _this2.alreadyTalking = false;
              return _context3.abrupt("return", _this2.startTalkingNow());
            case 47:
              _context3.prev = 47;
              console.log("about to call AI");
              // send off audio blob to server to get response
              console.log("AICALL three");
              _context3.next = 52;
              return _this2.askAI(blob);
            case 52:
              result = _context3.sent;
              _context3.next = 55;
              return _this2.handleAIResponse(result);
            case 55:
              _context3.next = 76;
              break;
            case 57:
              _context3.prev = 57;
              _context3.t0 = _context3["catch"](47);
              console.log("issue with calling AI", _context3.t0);
              _this2.$store.commit("updateSpeakToProcess", "Sorry, I didn't hear you. Did you say something? If so, try to speak louder perhaps.");
              // reask the question
              if (_this2.simultaneousTalking) {
                _context3.next = 76;
                break;
              }
              _this2.alreadyTalking = false;
              if (!(_this2.$store.state.onDeviceAudioRecording === false)) {
                _context3.next = 71;
                break;
              }
              if (!_this2.$store.state.continuousListenMode) {
                _context3.next = 68;
                break;
              }
              return _context3.abrupt("return", _this2.startTalkingNow());
            case 68:
              return _context3.abrupt("return");
            case 69:
              _context3.next = 76;
              break;
            case 71:
              if (!_this2.$store.state.continuousListenMode) {
                _context3.next = 75;
                break;
              }
              return _context3.abrupt("return", _this2.startTalkingNowOnDevice());
            case 75:
              return _context3.abrupt("return");
            case 76:
              // message coming back might be 'only ai audio detected'

              // good request

              if (!result.badRequest && !result.only_ai_audio_detected) {
                if (result === "Internal Server Error") {
                  result.aiResponse = "Sorry, I must have zoned out for a minute or maybe I am having a bad day. Can you ask me again?";
                }
              }
            case 77:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[47, 57]]);
      }))();
    },
    repeatQuestion: function repeatQuestion() {
      this.$store.commit("updateRepeatLastQuestion", true);
    },
    repeatAnswer: function repeatAnswer() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var lastSentences, j, content, utf8Encoded, sentenceBase64, last8Characters;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(_this3.$store.state.lastSentences.length === 0)) {
                _context4.next = 2;
                break;
              }
              return _context4.abrupt("return");
            case 2:
              lastSentences = _this3.$store.state.lastSentences;
              _this3.$store.commit('clearLastSentences');
              // clear the queue index mapping so messages come in correct order
              _this3.$store.commit('clearQueueIndexMapping');
              // add placeholders for sentence,animation,audio object incoming for cloud
              _this3.$store.commit('addQueuedTTSPlaceholders');
              _this3.$store.commit("updateProcessingCloudTTSPayloads", false);
              console.log("trying to repeat answer", lastSentences);
              if (!lastSentences.length) {
                _context4.next = 23;
                break;
              }
              j = 0;
            case 10:
              if (!(j < lastSentences.length)) {
                _context4.next = 23;
                break;
              }
              content = lastSentences[j];
              utf8Encoded = unescape(encodeURIComponent(content));
              sentenceBase64 = btoa(JSON.stringify(utf8Encoded));
              last8Characters = sentenceBase64.slice(-8); // console.log(`handle 3 ${messageIndex} for - ${content} ${last8Characters}`);
              _this3.$store.commit('addQueueIndexMapping', {
                value: j,
                key: last8Characters
              });
              console.log("sentence to respeak", lastSentences[j]);
              _this3.$store.commit("updateSpeakToProcess", lastSentences[j]);
              _context4.next = 20;
              return new Promise(function (r) {
                return setTimeout(r, 500);
              });
            case 20:
              j++;
              _context4.next = 10;
              break;
            case 23:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    manyButtonsAction: function manyButtonsAction() {
      if (localStorage.getItem('limitReached') === 'true' || localStorage.getItem('limitReached') === true) {
        this.$store.commit('updateUpgradeModalMessage', 'limitreached');
        this.$store.commit("updateShowUpgradeMembershipPage", true);
        this.$store.commit('updateLimitReached', true);
        return;
      }
      if (this.$store.state.limitReached === true || this.$store.state.limitReached === "true") {
        this.$store.commit('updateUpgradeModalMessage', 'limitreached');
        this.$store.commit("updateShowUpgradeMembershipPage", true);
        this.$store.commit('updateLimitReached', true);
        return;
      }
      console.log('[manyButtonsAction top]');
      this.$store.commit('updateTalkButtonHit', true);
    },
    returnTalkingIcon: function returnTalkingIcon() {
      if (this.$store.state.brillianceMode && !this.$store.state.isListening) {
        return "fa-brain-circuit";
      }
      if (this.$store.state.conversationOngoing && !this.$store.state.isListening) {
        // return 'Stop Talking'
        return "fa-user";
      }
      if (this.aiIsResponding && !this.$store.state.isListening) {
        // return 'Conversation Mode On'
        // return 'Stop Responding'
        return "fa-stop-circle";
      }
      if (this.$store.state.isListening && this.$store.state.conversationOngoing) {
        // return 'Listening...';
        // return 'Stop Listening'
        return "fa-stop-circle";
      }
      if (!this.$store.state.continuousListeningActive && this.$store.state.continuousListenMode) {
        // return 'Start Continuous Listening';
        return "fa-infinity";
      }
      if (this.$store.state.continuousListeningActive) {
        // return 'Stop Listening'
        return "fa-stop-circle";
      }
      // return 'Unmute Mic';
      return "fa-microphone";
    },
    returnButtonHolderStyle: function returnButtonHolderStyle() {
      if (this.$store.state.appSettingsRightHanded === "true" || this.$store.state.appSettingsRightHanded === true) {
        return "'right':'0px'";
      } else {
        return "'left':'0px'";
      }
    }
  }
});